import SoftSignalIcon from './SoftSignalIcon.component';

export default SoftSignalIcon;
